import { environment } from "src/environments/environment"


 export class AppConstants {
  public static  IMAGEURL = "assets/img/"
  public static apiBaseUrl = environment.LIVE_CLASS_API
  public static displayProPlus = environment.displayProPlus
  public static cmsUrl = environment?.CMS_API;
  public static liveClassV2 = environment.LIVE_CLASS_API_V2

 public static APIURL = {
  class: `${AppConstants.apiBaseUrl}eclasses`,
  student: AppConstants.apiBaseUrl + "students",
  course: AppConstants.apiBaseUrl + "courses",
  courseEnroll: AppConstants.apiBaseUrl + "studentEnrollment",
  classList: AppConstants.apiBaseUrl + "eclasses/student/all",
  teachers: AppConstants.apiBaseUrl + "teachers",
  allTeachers: AppConstants.apiBaseUrl + "teachers/Allteachers",
  agora: AppConstants.apiBaseUrl + "agora",
 }
}
